export default __webpack_public_path__ + "static/media/minh.78cde592.jpg";